import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import classnames from "classnames";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import settings from "client.settings.json";
import { translate } from "reducers/i18n";
import { useParams } from "react-router-dom";
import { useState } from "react";

const { api } = settings;

const DeleteAuthenticator = ({ authId, setAuthenticators }) => {
  const { messageId } = useParams();
  const [isDeleting, setIsDeleting] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleShowConfirmation = () => setShowConfirmation(prev => !prev);

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      setAuthenticators(prev => prev.filter(({ _id }) => _id !== authId));
      await axios.post(`${api}/api/login/authenticator/${authId}`, { messageId });
    } catch (error) {
      console.error(error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-outline-danger d-inline-flex align-items-center px-1 py-1 ml-auto"
        onClick={handleShowConfirmation}
      >
        <FontAwesomeIcon className="m-0" icon={faTimes} fixedWidth />
      </button>
      <div className={classnames("collapse mt-3 mb-2 w-100", { show: showConfirmation })}>
        <p>{translate("authenticator_confirm_delete")}</p>
        <button type="button" className="btn btn-secondary mr-3" onClick={handleShowConfirmation}>
          {translate("_cancel")}
        </button>
        <button type="button" className="btn btn-danger" disabled={isDeleting} onClick={handleDelete}>
          {translate("_delete")}
        </button>
      </div>
    </>
  );
};

export default DeleteAuthenticator;
